import React from 'react';

import Style from '../styles/componentStyle/safetyDocItemIcon.scss';

/**
 * 安全書類項目アイコン
 * @returns
 */
const SafetyDocItemIcon = ({ isFormListDefault = false }) => {
  return (
    <span
      className={`
        ${
          isFormListDefault ? 'SafetyDocItemIcon' : `${Style.safetyDocItemIcon}`
        }
      `}
    >
      安全書類項目
    </span>
  );
};

export default SafetyDocItemIcon;



// WEBPACK FOOTER //
// ./src/components/SafetyDocItemIcon.jsx